// Copyright (c) 2017 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';

export const getWipStatuses = statuses =>
    statuses
        .filter(status => ['01', '1', '4', '6', '7', '8', '9', '16'].includes(status.key))
        .map(status => new KeyValuePair({
            key: status.key,
            value: status.value
        }));



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/services/claims-in-progess-helper.js